import { render, staticRenderFns } from "./FeedBack.vue?vue&type=template&id=6df2830a&scoped=true"
import script from "./FeedBack.vue?vue&type=script&lang=js"
export * from "./FeedBack.vue?vue&type=script&lang=js"
import style0 from "./FeedBack.vue?vue&type=style&index=0&id=6df2830a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2830a",
  null
  
)

export default component.exports